import React from "react";

const Discussion = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M12.667 24.764h15.599l2.686 2.102v-15.76h1.524c.404 0 .792.16 1.078.444.285.285.446.67.446 1.073v20.488L27.211 27.8h-13.02c-.405 0-.792-.16-1.078-.445a1.515 1.515 0 0 1-.446-1.073v-1.518ZM8.789 21.73 2 27.041V3.518c0-.403.16-.789.446-1.073A1.527 1.527 0 0 1 3.524 2H26.38c.404 0 .792.16 1.078.445.285.284.446.67.446 1.073v18.211H8.789Z"
              fill={fill}
        />
    </svg>
);

export default Discussion;